'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCasinoTournament = exports.getFullLeaderboard = exports.getRelativeLeaderboard = exports.getLeaderboard = undefined;

var _action = require('../../lib/action');

var _tournament = require('tg-core-api/lib/tournament');

var _tournament2 = _interopRequireDefault(_tournament);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLeaderboard = exports.getLeaderboard = function getLeaderboard(tournamentId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  return (0, _action.makeApiCallAction)('GET_LEADERBOARD', _tournament2.default.getLeaderboard(tournamentId, offset, limit));
};

var getRelativeLeaderboard = exports.getRelativeLeaderboard = function getRelativeLeaderboard(tournamentId, playerId) {
  var playersBeforeAndAfter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return (0, _action.makeApiCallAction)('GET_RELATIVE_LEADERBOARD', _tournament2.default.getRelativeLeaderboard(tournamentId, playerId, playersBeforeAndAfter));
};

var getFullLeaderboard = exports.getFullLeaderboard = function getFullLeaderboard(tournamentId) {
  return (0, _action.makeApiCallAction)('GET_LEADERBOARD', _tournament2.default.getFullLeaderboard(tournamentId));
};

var getCasinoTournament = exports.getCasinoTournament = function getCasinoTournament(gameId) {
  return (0, _action.makeApiCallAction)('GET_CASINO_TOURNAMENT', _tournament2.default.getCasinoTournament(gameId));
};

exports.default = {
  getLeaderboard: getLeaderboard,
  getRelativeLeaderboard: getRelativeLeaderboard,
  getFullLeaderboard: getFullLeaderboard,
  getCasinoTournament: getCasinoTournament
};